/** Jump-course pieces: hazard art that dresses `spikes` zones (the zone, not the art, decides death). */
import { definePiece } from '../../definePiece';
import type { PieceDefinition } from '../../contract';
import { buildSpikeStrip, COURSE_SPIKE_STRIP, COURSE_SPIKE_STRIP_HANGING } from './spikeStrip';

export const COURSE_PIECES = {
  spike_strip: definePiece(COURSE_SPIKE_STRIP, buildSpikeStrip, {
    sparse_clean: { facing: 'up', teeth: 4, rust: 0 },
    dense_rusted: { facing: 'up', teeth: 7, rust: 1 },
  }),
  spike_strip_hanging: definePiece(COURSE_SPIKE_STRIP_HANGING, buildSpikeStrip, {
    dense_rusted: { facing: 'down', teeth: 7, rust: 1 },
  }),
} as const satisfies Record<string, PieceDefinition>;
